import Slider from '../slider';

export default (element, data) => {
  const elementSlider = element.querySelector('[data-manual-ugc-slider]');
  const elementSlides = element.querySelectorAll('[data-manual-ugc-slider-slide]');
  const prevEl = element.querySelector('[data-arrow-manual-ugc-left]');
  const nextEl = element.querySelector('[data-arrow-manual-ugc-right]');
  if (!elementSlider) return;
  const { layout } = data;
  let slider = null; 

  const manageClasses = (action) => {
    const sliderWrapper = element.querySelector('[data-manual-ugc-slider-wrapper]');
    if (elementSlider) elementSlider.classList[action]('swiper', '!static');
    if (sliderWrapper) sliderWrapper.classList[action]('swiper-wrapper', '!static');
    elementSlides.forEach(slide => slide.classList[action]('swiper-slide'));
  };

  const checkCopyForUnderline = () => {
    const copies = element.querySelectorAll('[data-manual-ugc-slider-copy]');
    copies.forEach((copy) => {
      if (copy) {
        const updatedHTML = copy.innerHTML.replace(/(@\w+)/g, '<u>$1</u>');
        const newElement = document.createElement('div');
        newElement.innerHTML = updatedHTML;

        Array.from(copy.classList).forEach(className => {
          newElement.classList.add(className);
        });
  
        copy.parentNode.replaceChild(newElement, copy);
      }
    });
  };
  

  const initSlider = () => {
    manageClasses('add');
    slider = new Slider({
      el: elementSlider,
      options: { 
        slidesPerView: 1.2,
        breakpoints: {
          1023: {
            slidesPerView: 3.3,
          },
          1536: {
            slidesPerView: 4.3,
          }
        },
        navigation: {
          nextEl,
          prevEl,
        }
      },
    });
  };

  const sliderCheck = () => {
    if (layout.isAboveBreakpoint('lg') && elementSlides.length < 4) {
      if(slider){
        slider.destroy(true, true);
        slider = null;
      }
      manageClasses('remove');
    } else if (!slider) {
      initSlider();
    }
  };

  const debounce = (func, wait, immediate) => {
    let timeout;
  
    return (...args) => {
      const context = this;
  
      const later = () => {
        timeout = null;
        if (!immediate) {
          func.apply(context, args);
        }
      };
  
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
  
      if (callNow) {
        func.apply(context, args);
      }
    };
  };
  
  const debouncedCheck = debounce(sliderCheck, 250);
  checkCopyForUnderline();
  sliderCheck(); 
  window.addEventListener('resize', debouncedCheck);
};
